import React from 'react';

// Events
import Ejection from './Events/Ejection';
import Faceoff from './Events/Faceoff';
import Fight from './Events/Fight';
import GoaliePulled from './Events/GoaliePulled';
import GoalieReplaced from './Events/GoalieReplaced';
import GoalieReturned from './Events/GoalieReturned';
import Hit from './Events/Hit';
import Icing from './Events/Icing';
import Injury from './Events/Injury';
import Offside from './Events/Offside';
import Penalty from './Events/Penalty';
import PenaltyShot from './Events/PenaltyShot';
import Shootout from './Events/Shootout';
import Shot from './Events/Shot';
import Unknown from './Events/Unknown';


function determineEventComponent({ event }){
  switch(event){
    case 'ejected':
      return Ejection;
    case 'faceoff':
      return Faceoff;
    case 'fight':
      return Fight;
    case 'goaliePulled':
      return GoaliePulled;
    case 'goalieReplaced':
      return GoalieReplaced;
    case 'goalieReturned':
      return GoalieReturned;
    case 'hit':
      return Hit;
    case 'icing':
      return Icing;
    case 'injury':
      return Injury;
    case 'offside':
      return Offside;
    case 'penalty':
      return Penalty;
    case 'penaltyShot':
      return PenaltyShot;
    case 'shootoutAttempt':
      return Shootout;
    case 'shot':
      return Shot;
    default:
      return Unknown;
  }
}


function GameEvents(props) {
  const Component = determineEventComponent(props.event)
  return <Component {...props} />
}

export default GameEvents;
